import type { Item, OfferItem } from '../SelectItems.types'

export const isOfferItemType = (item: Item): item is Extract<Item, OfferItem> =>
  item.type === 'OFFER'
